import { getAtomsShoesBaseCells, getAtomsShoesColorsCells } from 'src/features/atoms/shoes/simulationSpecification'
import { Embroidery, I18NText, ShoesState } from 'src/types'

export const getShoesBaseCells = (state: ShoesState) => {
  const brand = state.baseModel.brand
  switch (brand) {
    case 'atoms':
      return getAtomsShoesBaseCells(state)
  }
}

export const getShoesColorCells = (state: ShoesState, brand = 'atoms') => {
  switch (brand) {
    case 'atoms':
      return getAtomsShoesColorsCells(state)
  }
}

export const genShoesEmbroideryCells = (embroidery: Embroidery, t: I18NText): { head: string; label: string; value?: string; color?: string }[] =>
  [
    {
      head: t.TYPE_FACE,
      label: embroidery.typeFace.label,
      value: embroidery.typeFace.value,
      color: embroidery.typeFace.color
    },
    {
      head: t.POSITION,
      label: embroidery.position.label,
      value: embroidery.position.value,
      color: embroidery.position.color
    },
    {
      head: t.MAIN_COLOR,
      label: embroidery.color.label,
      value: embroidery.color.value,
      color: embroidery.color.color
    },
    embroidery.typeFace.value === 'arriba' && {
      head: t.POINT_COLOR,
      label: embroidery?.pointColor?.label,
      value: embroidery?.pointColor?.value,
      color: embroidery?.pointColor?.color
    },
    { head: t.EMBROIDERY_CONTENTS, label: embroidery.content }
  ].filter(Boolean)
